import { CurriedFunction1, CurriedFunction2, CurriedFunction3, CurriedFunction4 } from 'lodash4';
import * as _4 from 'lodash4';

export class RegularExpression {
  static COLOR_HEX: RegExp = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
  static COLOR_CSS_RGBA: RegExp = /^rgb?a\((\d{1,3}),(\d{1,3}),(\d{1,3}),?(\d{1,3})?\)$/i;
  static PHONE_NUMBER: RegExp = /\b(\+*\d{1,})*([ |\(.-])*(\d{3})[^\d]*(\d{3})[^\d]*(\d{4})\b/g;
  static DIGITS: RegExp = /\d/g;
  static SANITIZED_STRING = /[\\<>\[\]`\|]|\$[a-z]{1,}|\);|\?[a-z]{1,}=[a-z]{1,}|%[a-z0-9]{1,}|&&/gim;

  static split: CurriedFunction2<RegExp, string, string[]> = _4.curry(
    (regularExpression: RegExp, value: string): string[] => {
      return value.split(regularExpression);
    }
  );

  static exec: CurriedFunction2<RegExp, string, string[]> = _4.curry(
    (regularExpression: RegExp, value: string): string[] => {
      return regularExpression.exec(value) || [];
    }
  );
}



// WEBPACK FOOTER //
// ./app/vendor/utility-ts-type/src/core/regular_expression.ts